import { Address } from '@anyx/shared-utils';

export const AddressOneDisplay = ({ address }: { address: Address; hasPrevious: boolean }) => {
  return address?.address1 ? <span>{address?.address1}</span> : null;
};
